import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ProjectDetailsServiceService } from '../project-details-service.service';
import { UtilsService } from '../services/utils.service';

@Component({
    selector: 'app-project-topbar',
    imports: [RouterModule],
    templateUrl: './project-topbar.component.html',
    styleUrl: './project-topbar.component.scss'
})
export class ProjectTopbarComponent {
  constructor(public utilsService:UtilsService,public activeRouter:ActivatedRoute,public projectDetailsService:ProjectDetailsServiceService) {
    this.activeRouter.params.subscribe((res:any)=>{
      this.projectDetailsService.projectId=res['id'];
      this.projectDetailsService.getSelectedProject();
    })

  }

  get projectSlug(): string {
    const project = this.projectDetailsService.selectedProject?.project;
    const routeValue = project?.customUrl || project?.projectName || this.projectDetailsService.projectId || '';

    return String(routeValue)
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

   openNav2() {
    var sidebar: any = document.getElementById('mySidenav2');
    if (sidebar) {
        sidebar.classList.remove('d-none'); // Remove d-none class
    }
}

 closeNav2() {
    var sidebar: any = document.getElementById('mySidenav2');
    if (sidebar) {
        sidebar.classList.add('d-none'); // Add d-none class
    }
}

openNav(){

  var sidebar: any = document.getElementById('mySidenav');
  if (sidebar) {
      sidebar.classList.remove('d-none'); // Remove d-none class
  }
}
closeNav(){
  var sidebar: any = document.getElementById('mySidenav');
  if (sidebar) {
      sidebar.classList.add('d-none'); // Add d-none class
  }
}

}
